module.exports = __webpack_public_path__ + "media/images/pricing/enterprise-81346a47237e773deeccdf69e015c33d.png";